<template>
  <div>
    <el-card class="mb-2" shadow="never">
      <div class="d-flex align-items-end">
        <div class="d-flex">
          <el-image
            :src="baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[
              baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            style="width: 134px; height: 88px"
            fit="cover"
          >
            <div slot="error">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 120px; height: 80px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex: 1;" class="ml-2">
          <h5 style="color: #101010;">
            {{ baseInfo.fabricName || '新增面料开发申请' }}
          </h5>
          <h6 style="color: #303133;font-size: 14px;">
            {{ baseInfo.fabricNameEn || '新增面料开发申请' }}
          </h6>
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div style="height: 29px;line-height: 29px;overflow: hidden;">
                <span style="font-size: 14px; color: #606266">
                  No：{{
                    baseInfo.fabricRequestNo || '面料开发申请编号自动生成'
                  }}
                </span>
                <el-divider direction="vertical" />
                <el-tag
                  size="mini"
                  :type="
                    baseInfo.fabricRequestStatus === 'Y'
                      ? 'success'
                      : baseInfo.fabricRequestStatus === 'P'
                      ? 'warning'
                      : ['D', 'B'].includes(baseInfo.fabricRequestStatus)
                      ? 'danger'
                      : ''
                  "
                >
                  {{ baseInfo.v_fabricRequestStatus || 'New' }}
                </el-tag>
                <el-divider direction="vertical" />
                <span style="font-size: 14px; color: #606266">
                  Modify：{{ baseInfo.modifyByName || '--' }} at
                  {{ baseInfo.modifyDate || '--' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card shadow="never">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :fabricRequestCode="fabricRequestCode"
          @loaded="(data) => (baseInfo = data)"
        />
        <div class="d-flex justify-content-end mt-3" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.editForm.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'master-fabricRequest-detail',
  components: { EditForm },
  data() {
    return { baseInfo: {} }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isCopy() {
      return this.pageType === 'copy'
    },
    disabled() {
      return this.pageType === 'detail'
    },
    fabricRequestCode() {
      return this.params.fabricRequestCode
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
